import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import gsap from 'gsap';

const handlePageInvert = (attributeState, className) => {
    if (attributeState) {
        document.body.classList.add(className);
        return;
    }

    document.body.classList.remove(className);
};

/**
 * Do the default transition logic.
 *
 * @param  {JSON} response
 * @param  {ctx} ctx
 * @return {void}
 */
export default (response, ctx, router) => {
    const app = document.getElementById('page-wrapper');
    const current = document.getElementById('page-container');

    EventBus.$once('page-transition-enter', () => {
        // Switch section.
        const ajaxTemplate = document.querySelector('.ajax-template');
        document.title = ajaxTemplate.dataset.title || document.title;
        document.body.classList.remove(router.currentSection);
        document.body.classList.add(ajaxTemplate.dataset.namespace);
        router.currentSection = ajaxTemplate.dataset.namespace;
        router.app.showFooter = ajaxTemplate.dataset.showFooter;
        router.app.darkHeader = ajaxTemplate.dataset.darkHeader;
        router.app.currentSlug = ajaxTemplate.dataset.pageSlug;

        handlePageInvert(ajaxTemplate.hasAttribute('data-page-inverted'), 'page--dark');
        handlePageInvert(ajaxTemplate.hasAttribute('data-header-inverted'), 'header--dark');

        router.app.showNavigation = false;
        router.app.$forceUpdate();

        if (router.app.currentSlug !== 'projects') {
            enableBodyScroll(document.querySelector('.header'));
        }

        gsap.delayedCall(0.7, () => {
            EventBus.$emit('page-transition-build-page');
        });
    });

    // Pass the component definition to the resolve callback
    EventBus.$once('transition-halfway', () => {
        window.scrollTo(0, 0);
        const next = document.createRange().createContextualFragment(response.data);
        app.appendChild(next);
        current.parentNode.removeChild(current);

        const template = document.querySelector('.ajax-template');
        if (template.dataset.pageSlug === 'projects') {
            console.log('Disabling body scroll');
            disableBodyScroll(document.querySelector('.header'));
            app.classList.add('percentage-height');
        } else {
            app.classList.remove('percentage-height');
        }

        // Rebuild Vue
        router.buildPage(app);
    });

    // Set transition color.
    // const ajaxTemplate = document.querySelector('.ajax-template');
    const next = document.createRange().createContextualFragment(response.data);
    // console.log(next.querySelector('.ajax-template'));
    const template = next.querySelector('.ajax-template');
    if (template.dataset) {
        window.transitionColor = template.dataset.color || null;
    }

    window.requestAnimationFrame(() => {
        EventBus.$emit('liquid-transition-start');
    });
};
